// user constants
export const CURRENT_USER_SCHEMA_VERSION = 'v1.2';
